<template>
  <div>
      <Reply :url="url" :key="company"></Reply>
  </div>
</template>

<script>
import Reply from "./reply.vue";
export default {
    components:{
        Reply
    },
    data() {
        return {
            url:'/admin/pc/reply/subscribe',
            company:1,
        }
    },
    mounted(){
    }
}
</script>

<style>

</style>